import { stdObject } from "../../../../data/types/stdObject";

export const createNewPart = (style: stdObject, params: stdObject) => {
  const { staValues, setStaValues } = params;
  const maxNum =
    staValues.parts.length === 0
      ? 1
      : Math.max(
          ...staValues.parts.map(({ NUMPAR }: { NUMPAR: number }) => NUMPAR),
        ) + 1;
  staValues.parts.push({
    ...style,
    CODPAR: staValues.data.CODDOC,
    NUMPAR: maxNum,
  });
  setStaValues({ ...staValues });
  return maxNum;
};
